import { GenericValidation } from '../../../../../../../validations/GenericValidation';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import { defaultBorrowerLegalName } from '../../../../../../../components/loan_application/form_models/constants';
import { BUSINESS_TYPE_FOR_PROFIT_OR_NON_PROFIT } from '../../../../../../../constants';

const {
  formField: { businessTypeForProfitOrNonProfit },
} = loanFormModel;

const {
  formField: { borrowerBusinessStructure },
} = loanFormModel;

export class BorrowerBusinessStructureValidation implements ValidationSchema {
  public name: string = borrowerBusinessStructure.name;
  public label: string = borrowerBusinessStructure.getLabel(
    defaultBorrowerLegalName
  );
  public dependsOn: string[] = [businessTypeForProfitOrNonProfit.name];
  public type = 'string';
  public required = {
    message: borrowerBusinessStructure.requiredErrorMsg,
    value: true,
  };
  public nullable = true;

  public when(
    businessType: BUSINESS_TYPE_FOR_PROFIT_OR_NON_PROFIT,
    schema: any
  ) {
    if (businessType === BUSINESS_TYPE_FOR_PROFIT_OR_NON_PROFIT.FOR_PROFIT)
      return schema;

    return GenericValidation.create({
      name: this.name,
      type: 'string',
      label: this.label,
      required: {
        value: false,
      },
      nullable: true,
    });
  }
}
export default new Validation(new BorrowerBusinessStructureValidation());
